import React, { Component } from "react";
import "../App.css";
import { getText } from "../Text";
import shanghai from "../static/img/shanghai_dark.jpg"
import mission_statement from "../static/img/mission_statement_test.jpg"
import services from "../static/img/services.jpg"
import our_team from "../static/img/our_team.jpg"
import service_area from "../static/img/service_area.png"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'

class Home extends Component {
	render() {
		const language = this.props.language

		return (
			<div className="App">
				<div className="background" style={{ backgroundImage: `url(${shanghai})` }}>
					<Container>
						<div className="bg-text">
							<h1 className="title"> {getText(language).home.header} </h1>
							<h3 className="textloop">
								<div>
									{getText(language).home.sentence_1}
								</div>
							</h3>
						</div>
					</Container>
				</div>
				<Container>
					<Row>
						<Col className="contactHeader">
							<h2 className="exitHeader">
								{getText(language).home.section1_header}
							</h2>
							<div className="body">
								{getText(language).home.section1_text}
								<br /><br />
								{getText(language).home.section1_text2}
							</div>

						</Col>
					</Row>
					<hr />
					<Row xs={1} xl={2}>
						<Col className="contactHeader">
							<h2 className="exitHeader">
								{getText(language).home.section2_header}
							</h2>
							<div className="body">
								{getText(language).home.section2_text}
								<br /><br />
								<ul>
									<li>{getText(language).home.section2_text1}</li>
									<li>{getText(language).home.section2_text2}</li>
									<li>{getText(language).home.section2_text3}</li>
									<li>{getText(language).home.section2_text4}</li>
								</ul>
							</div>
						</Col>
						<Col>
							<Image className="mission_statement" src={our_team} />
						</Col>
					</Row>
					<hr />
					<Row xs={1} xl={2}>
						<Col>
							<Image className="mission_statement" src={services} />
						</Col>
						<Col className="contactHeader">
							<h2 className="exitHeader">
								{getText(language).home.section3_header}
							</h2>
							<div className="body">
								{getText(language).home.section3_text1} <br /><br />
								<ul>
									<li>{getText(language).home.section3_text2}</li>
									<li>{getText(language).home.section3_text3}</li>
									<li>{getText(language).home.section3_text5}</li>
								</ul>
								<br />
							</div>
						</Col>
					</Row>
					<div className="bottom-text">
						{getText(language).home.section3_text4}
					</div>
					<hr />
					<Row xs={1} xl={2}>
						<Col className="contactHeader">
							<h2 className="exitHeader">
								{getText(language).home.section4_header}
							</h2>
							<div className="body">
								<b>{getText(language).home.section4_text1}</b><br /><br />
								<ul>
									<li>{getText(language).home.section4_text2}</li>
									<li>{getText(language).home.section4_text3}</li>
									<li>{getText(language).home.section4_text4}</li>
								</ul>
								<br />
							</div>
						</Col>
						<Col>
							<Image className="mission_statement" src={mission_statement}></Image>
						</Col>
					</Row>
					<hr />
					<Row>
						<Col className="contactHeader">
							<h2 className="exitHeader">
								{getText(language).home.section5_header}
							</h2>
							<Image className="service_area" src={service_area} />
						</Col>
					</Row>

				</Container>
			</div>
		);
	}
}

export default Home;
